import React from 'react';
import {useTranslation} from 'react-i18next';
import {BoxType} from '@taopix/taopix-core';
import {TextBoxIcon} from '@taopix/taopix-design-system';
import AddItemButton from './AddItemButton';

const AddTextBoxButton = ({enabled, pageNumber, buttonProps}) => {
  const {t} = useTranslation();
  return (
    <AddItemButton
      boxType={BoxType.Text}
      enabled={enabled}
      pageNumber={pageNumber}
      buttonProps={buttonProps}
      icon={<TextBoxIcon />}
      label={t('str_LabelAddTextBox', {
        ns: 'stubar',
      })}
    />
  );
};

export default AddTextBoxButton;
